import {Box, Typography} from "@mui/material";
import IconWrapper from "components/IconWrapper";
import DefaultLayout from "layout/defaultLayout";
import DisplayAdsIcon from "assets/images/IconDisplayAdsWithBG.svg";
import CustomButtonWithIcon from "../../../components/CustomButtonWithIcon/Buttons";
import React, {useState} from "react";
import "./SignUpDisplayAdsPage.scss";
import SignUpFormDisplayAds from "features/product-sign-up/SignUpFormDisplayAds";

const SignUpDisplayAdsPage = () => {

    const [isPanelOpen, setPanelOpen] = useState(false);
    const togglePanel = () => {
        setPanelOpen((prev) => !prev);
    };

    return (
      <DefaultLayout page="Display Ads">
        <Box className="displayAdsSignUpPage">
          <div className="header-container">
            <div>
              <div className="header-left">
                <div className="icon-wrapper">
                  <IconWrapper icon={DisplayAdsIcon} />
                </div>
                <div>
                  <Typography className="quency-cf-normal heading">
                    Display Ads
                  </Typography>
                </div>
              </div>
            </div>
          </div>
          <div className="summary-section">
            <Typography gutterBottom className="summary-title">
              SUMMARY
            </Typography>

            <Typography variant="body1" className="summary-text">
              <p className="summary-text-bold">
                Boost Your Online Presence and Drive Results with Display Ads
              </p>
              In today’s competitive digital landscape, Display Ads is one of
              the most powerful ways to ensure your business is seen by the
              right people. Our platform makes it easy for you to create,
              manage, and optimize Display Ads campaigns. Whether you're looking
              to increase traffic, generate leads, or boost sales, our platform
              offers advanced targeting options, real-time analytics, and the
              flexibility to scale your campaigns based on your goals and
              budget. With seamless automation and expert support at your
              fingertips, you'll be able to focus on what matters—growing your
              business.
              <p className="summary-text-bold">
                Ready to Grow with Display Ads?
              </p>
              Don’t miss out on the opportunity to put your business in front of
              customers actively searching for what you offer. Join the hundreds
              of hotels already benefiting from our Display Ads campaigns. Our
              platform is designed to help you achieve measurable results and
              maximize your ROAS. Contact us today to schedule a free demo and
              discover how easy it is to get started with Display Ads. Let’s
              grow together—reach out now to begin your journey!
            </Typography>

            <CustomButtonWithIcon
              onClick={togglePanel}
              color="#b0acac"
              hoverColor="#61D5A9"
              width="201px"
              height="44px"
              titleColor="#373F41"
              borderRadius="20px"
              title="Request a Demo"
              iconBorder="0.5px solid #373F41"
              textStyle={{
                display: "flex",
                fontFamily: "Inter",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "14.52px",
                textAlign: "center",
              }}
            >
              Request a Demo
            </CustomButtonWithIcon>
          </div>
        </Box>
            <SignUpFormDisplayAds isOpen={isPanelOpen} onClose={togglePanel}/>
      </DefaultLayout>
    );
};
export default SignUpDisplayAdsPage;
